import UsageBlock from '@components/usageblock';
import TabbedIcons from "..\\..\\..\\..\\content\\foundations\\iconography\\tabbedIcons";
import * as React from 'react';
export default {
  UsageBlock,
  TabbedIcons,
  React
};